import { Component, Input } from '@angular/core';
import { HelpArticleKey } from '@shared/modules/help-desk/articles';

@Component({
    selector: 'app-help-button',
    templateUrl: './help-button.component.html',
    styleUrls: ['./help-button.component.scss']
})
export class HelpButtonComponent {
    @Input() article: HelpArticleKey;
    @Input() icon: string = 'help_outline';
    @Input() small: boolean = false;
}
